import React from 'react'
import moment from 'moment'
import cl from 'classnames'
import swal from "sweetalert2"
import Modal from 'components/Modal'
import lodash from 'lodash'
import { smoothScroll, formatNumber, img, commingSoonFnc, isStartEvent } from 'components/common'
import ReactTooltip from 'react-tooltip'
class BannerSection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: null,
            isMobile: false,
            full_name: '',
            phone: '',
            address: '',
            site_info: null,
        }
    }
    handleClosePopup() {
        this.setState({ modal: null })
        $('body').removeClass('modal-open');
    }
    handleOpenPopup(modal) {
        this.setState({ modal: modal })
        $('body').addClass('modal-open');
    }
    componentDidMount() {
        if ($(window).width() < 1023) {
            this.setState({
                isMobile: true,
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.parentProp.home.site_info != null && !nextProps.parentProp.home.loading) {
            this.setState({
                site_info: nextProps.parentProp.home.site_info
            })
        }
    }
    onChangeInfo(value, type) {
        switch (type) {
            case 'full_name':
                this.setState({
                    full_name: value
                })
                break;
            case 'phone':
                this.setState({
                    phone: value
                })
                break;
            case 'address':
                this.setState({
                    address: value
                })
                break;
            default:
                break;
        }
    }
    onUpdateInfo() {
        if (this.state.full_name.trim() == '' || this.state.phone.trim() == '' || this.state.address.trim() == '') {
            swal({
                title: 'Thông báo',
                html: '<p class="pop-content">Bạn phải điền đầy đủ thông tin cá nhân.</p>',
                confirmButtonText: 'Đóng',
                animation: false,
                customClass: 'custom-modal animated zoomIn'
            })
            return
        }
        let phoneRGEX = /^[0-9]{10,11}$/;
        if (!phoneRGEX.test(this.state.phone)) {
            swal({
                title: 'Thông báo',
                html: '<p class="pop-content">SĐT không đúng định dạng, vui lòng nhập lại.</p>',
                confirmButtonText: 'Đóng',
                animation: false,
                customClass: 'custom-modal animated zoomIn'
            })
            return
        }
        this.props.parentProp.UpdateInfo(this.state.full_name, this.state.address, this.state.phone, this.callBackReturn.bind(this))
    }
    callBackReturn() {
        this.handleClosePopup()
    }
    render() {
        const { modal, isMobile, full_name, phone, address, site_info } = this.state
        return (
            <React.Fragment>
                <section className="home-section">
                    <div className="wrap-gift">
                        {img('images/main-gift.png')}
                    </div>
                    <div className="wrap-title">
                        <h3 className="page-title">
                            <span className="p-title" data-aos="zoom-in-left">{img('images/banner-title.png')}</span>
                        </h3>
                        <p className="des" data-aos="fade-left" data-aos-delay="300">{img('images/b_slogan.png')}</p>
                        <p className="page-des" data-aos="zoom-in-right"> <span>Từ {site_info || '06.04 - 03.05.2020'}</span></p>
                        {/* <div className="group-btn" data-aos="fade-right" data-aos-delay="300">
                            <a href="javascript:void(0)" onClick={() => smoothScroll('.mission-section')}>tham gia ngay</a>
                            <a href="javascript:void(0)" onClick={() => this.handleOpenPopup('rule-pop')}>hướng dẫn</a>
                        </div> */}
                    </div>
                </section>
                {/* <Modal show={modal === 'rule-pop'} customClass={'pop-gift'} closeHandler={() => this.handleClosePopup()}>
                    <div className="text-center">
                        <img src="https://cdn.vn.garenanow.com/web/fo4vn/2019-Nov/RoadtoGoal/RoadToGoalpopup1.png" alt="" />
                    </div>
                </Modal> */}
            </React.Fragment>
        )
    }
}

export default BannerSection



// WEBPACK FOOTER //
// ./src/components/event/BannerSection.js